module.exports = __webpack_public_path__ + "img/descargar_todo.69c960ca.svg";